import { PremiumBadge } from "@/common/components/premium-badge/premium-badge";

class TrialStrategy {
  public wrapWith() {
    return PremiumBadge;
  }
}

export { TrialStrategy };
